<template>
  <div class="ml-2">
    <v-dialog v-model="dialogDetailCombo" max-width="70%">
      <DetailCombo
          v-if="currentCombo && currentCombo.id"
          :comboId="currentCombo.id"
          ref="detailCombo"
          @close="dialogDetailCombo = false"
      >
      </DetailCombo>
    </v-dialog>
    <v-data-table
        ref="table"
        :items="combos"
        :loading="loadingCourses"
        :headers="headers"
        hide-default-footer
        loading-text="Buscando..."
        no-data-text="Sem registros"
        class="elevation-0 mytable content-table"
        style="width: 110%"
    >
      <template v-slot:[`item.price`]="{ item }">
        {{ formatCurrency(item.price) }}
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <section class=" ">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  outlined
                  fab
                  tile
                  style="border-radius: 4px"
                  width="35"
                  height="35"
                  small
                  class="ma-1 quinary-button"
                  color="quaternary"
                  @click="showDialogDetailCourse(item)"
                  v-bind="attrs"
                  v-on="on"
              >
                <v-icon dark>mdi-eye-outline</v-icon>
              </v-btn>
            </template>
            <span>Detalhar</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  outlined
                  fab
                  tile
                  style="border-radius: 4px"
                  width="35"
                  height="35"
                  small
                  class="ma-1 quinary-button"
                  color="quaternary"
                  @click="edit(item.id)"
                  v-bind="attrs"
                  v-on="on"
              >
                <v-icon dark>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  outlined
                  fab
                  tile
                  style="border-radius: 4px"
                  width="35"
                  height="35"
                  small
                  class="ma-1 remove-button"
                  color="red"
                  @click="deleteClient(item)"
                  v-bind="attrs"
                  v-on="on"
              >
                <v-icon dark>mdi-trash-can-outline</v-icon>
              </v-btn>
            </template>
            <span>Remover</span>
          </v-tooltip>
        </section>
      </template>

      <template v-slot:footer class="ma-0 pa-0">
        <section class="ma-0 pa-0">
          <Pagination
              v-if="filter.totalItems > filter.pageSize"
              :currentPage="filter.currentPage"
              :totalItems="filter.totalItems"
              :page="filter.page"
              :pageSize="filter.pageSize"
              :totalPages="filter.totalPages"
              @back-page="backPage"
              @next-page="nextPage"
          >
          </Pagination>
        </section>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Utils from "../../../../Utils/FormatDate";
import UtilsFormatCurrency from "../../../../Utils/FormatCurrency";
import Pagination from "@/views/pages/components/Pagination.vue";
import DetailCombo from "@/views/pages/Courses/components/DetailCombo.vue";

export default {
  name: "Combos",
  components: {DetailCombo, Pagination},
  computed: {},

  props: {},

  created() {
  },

  async mounted() {
    await this.paginatedList()
  },
  data() {
    return {
      dialogDetailCombo: false,
      loadingCourses: false,
      currentCombo: Object,
      combos: [],
      headers: [
        {
          text: "Nome",
          align: "start",
          value: "name",
          sortable: false,
        },
        {
          text: "Descrição",
          align: "center",
          value: "description",
          sortable: false,
        },
        {
          text: "Preço",
          align: "center",
          value: "price",
          sortable: false,
        },
        {
          text: "Ações",
          align: "center",
          value: "actions",
          sortable: false,
        },
      ],
      activeTab: 0,
      apiService: new ApiService(),
      filter: {
        pageSize: 10,
        currentPage: 0,
        page: 1,
        totalPages: 1,
        totalItems: 1,
      },
      periods: [
        {name: "Matutino", value: "0"},
        {name: "Vespertino", value: 1},
        {name: "Noturno", value: 2}
      ],
      levels: [
        {name: "Iniciante", value: "0"},
        {name: "Intermediário", value: 1},
        {name: "Avançado", value: 2}
      ],
      daysOfTheWeek: [
        {name: "Domingo", value: 0},
        {name: "Segunda-feira", value: 1},
        {name: "Terça-feira", value: 2},
        {name: "Quarta-feira", value: 3},
        {name: "Quinta-feira", value: 4},
        {name: "Sexta-feira", value: 5},
        {name: "Sábado", value: 6}
      ],
    };
  },

  methods: {
    showDialogDetailCourse(course) {
      this.currentCombo = course
      this.dialogDetailCombo = true
      setTimeout(() => {
        this.$refs.detailCombo.getCombo()
      }, 100)
    },

    formatDaysOfTheWeek(daysOfTheWeek) {
      return this.daysOfTheWeek.filter(x => daysOfTheWeek.includes(x.value)).map(x => x.name).join(', ')
    },

    formatLevel(level) {
      return this.levels.find(x => x.value == level).name;
    },

    formatPeriod(period) {
      return this.periods.find(x => x.value == period).name;
    },

    formatDate(date) {
      return Utils.moment(date);
    },

    formatCurrency(value) {
      return UtilsFormatCurrency.formatCurrency(value);
    },

    async goToRoute(route) {
      await this.$router.push(route);
    },

    async paginatedList() {
      try {
        const {items, pager} = await this.apiService.post("combo/paginated", this.filter, false)
        console.log('items')
        console.log(items)
        console.log('items')
        this.combos = items
        this.filter.totalItems = pager.totalItems
        this.filter.currentPage = pager.currentPage
        this.filter.pageSize = pager.pageSize
        this.filter.totalPages = pager.totalPages
      } catch (e) {

      }
    },

    async backPage() {
      this.filter.page -= 1;
      await this.paginatedList();
    },

    async nextPage() {
      this.filter.page += 1;
      await this.paginatedList();
    },
    async edit(comboId) {
      await this.$router.push({
        path: `/combos-cadastrar`,
        query: {comboId}
      });
    }
  },

  watch: {},
};
</script>

<style lang='scss' scoped>
.mytable .v-table tbody tr {
  border-left: 5px solid red !important;
}

@media (max-width: 1024px) {
  .mytable {
    max-width: 100%;
  }
}
</style>
